import { render, staticRenderFns } from "./DetailsTab.vue?vue&type=template&id=432785c0&scoped=true"
import script from "./DetailsTab.component.js?vue&type=script&lang=js&external"
export * from "./DetailsTab.component.js?vue&type=script&lang=js&external"
import style0 from "./DetailsTab.vue?vue&type=style&index=0&id=432785c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432785c0",
  null
  
)

export default component.exports